import configure from "configure"
import React from "react"
import { Navigate } from "react-router-dom"
import secureLocalStorage from "react-secure-storage"

const Authmiddleware = props => {
  if (
    !localStorage.getItem("auth_id") &&
    !secureLocalStorage.getItem("auth_name") &&
    !secureLocalStorage.getItem("auth_role") &&
    !secureLocalStorage.getItem("auth_avt")
  ) {
    return (
      <Navigate
        to={{
          pathname: `${configure.appUrl}login`,
          state: { from: props.location },
        }}
      />
    )
  }
  return <React.Fragment>{props.children}</React.Fragment>
}

export default Authmiddleware
